import {Component, Input, OnInit} from '@angular/core';
import {CornerNameFromImageModel} from '../../../../../models/questions/subModels/cornerNameFromImage.model';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {EvoListSelectorService} from '../../../../../shared/modals/evo-list-selector/evo-list-selector.service';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-corner-name-from-image',
  templateUrl: './evo-corner-name-from-image.component.html',
  styleUrls: ['./evo-corner-name-from-image.component.css']
})
export class EvoCornerNameFromImageComponent implements OnInit {

  Enums = Enums;
  @Input() question: QuestionModel = new CornerNameFromImageModel();

  constructor(private selectorSv: EvoListSelectorService) { }

  ngOnInit() {
  }

  castedQuestion(): CornerNameFromImageModel {

    return <CornerNameFromImageModel>this.question;
  }

  removeCornerType(index: number) {
    if (index < this.castedQuestion().model.possibleAnswers.length) {
      this.castedQuestion().model.possibleAnswers.splice(index, 1);
    }
  }

  showCornerSelection() {
    this.selectorSv.showList(Enums.Corners.list(), this.castedQuestion().model.possibleAnswers).subscribe((item) => {
      if (item) {
        this.castedQuestion().model.possibleAnswers.push(item);
      }
    });
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.cornerNameFromImage) {
        return true;
      }
    }

    return false;
  }

}
